window.global = window;

// Handle dynamic import/chunk loading failures (due to new deployments) silently by reloading the page
window.addEventListener('error', (e) => {
  const isChunkError = e.message && (
    e.message.includes('Failed to fetch dynamically imported module') ||
    e.message.includes('error loading dynamically imported module')
  );
  if (isChunkError) {
    console.warn("Dynamic import failed. Reloading page to fetch latest version...");
    window.location.reload();
  }
}, true);

window.addEventListener('unhandledrejection', (e) => {
  const isChunkError = e.reason && e.reason.message && (
    e.reason.message.includes('Failed to fetch dynamically imported module') ||
    e.reason.message.includes('error loading dynamically imported module')
  );
  if (isChunkError) {
    console.warn("Dynamic import promise rejected. Reloading page to fetch latest version...");
    window.location.reload();
  }
});

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css'
import './styles/toast.css'
import App from './App.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
